import { useRouter } from 'next/router';

import { addQueryToRecentSearches } from 'src/utils/recentSearchesFromLocalStorage';

import SearchCombobox from 'components/BaseHelpers/SearchCombobox';
import { getTypeaheadResultsFactory } from 'components/Core/CoreGlobalNavigationHeader/components/SearchInput/getTypeaheadResult';

import { newsInsightsTypeaheadValueSchema } from '../../utils';

export type NewsInsightsSearchComboboxProps = {
  placeholder: string;
  typeaheadResultsCount: number;
  recentSearchesLabel: string;
  className?: string;
  queryDraft: string;
  setQueryDraft: (query: string) => void;
  submitQuery: (query: string) => void;
};

const NewsInsightsSearchCombobox = (props: NewsInsightsSearchComboboxProps): JSX.Element => {
  const {
    placeholder,
    typeaheadResultsCount,
    recentSearchesLabel,
    className,
    queryDraft,
    setQueryDraft,
    submitQuery,
  } = props;
  const router = useRouter();
  const localStorageKey = 'newsInsightsLandingRecentSearches';

  const handleSubmit = (query: string) => {
    addQueryToRecentSearches(
      {
        title: query,
        value: JSON.stringify({ title: query, href: '', type: 'query' }),
      },
      localStorageKey
    );
    setQueryDraft(query);
    submitQuery(query);
  };

  return (
    <SearchCombobox
      className={className}
      getTypeaheadResult={getTypeaheadResultsFactory('/api/news-insights-search/typeahead')}
      inputValue={queryDraft}
      localStorageKey={localStorageKey}
      onInputValueChange={setQueryDraft}
      onSubmit={handleSubmit}
      placeholder={placeholder}
      recentSearchesLabel={recentSearchesLabel}
      typeaheadResultsCount={typeaheadResultsCount}
      onSelect={(e) => {
        const result = newsInsightsTypeaheadValueSchema.safeParse(JSON.parse(e.itemValue));
        if (!result.success) {
          console.error('Invalid typeahead value:', result.error);
          return;
        }
        const { href, title, type } = result.data;
        if (type === 'query') {
          handleSubmit(title);
          return;
        } else if (type === 'link') {
          router.push(href);
        } else {
          const never: never = type;
          return never;
        }
      }}
    />
  );
};

export default NewsInsightsSearchCombobox;
